import { render, staticRenderFns } from "./familyInfo.vue?vue&type=template&id=adf50404&scoped=true&"
import script from "./familyInfo.vue?vue&type=script&lang=js&"
export * from "./familyInfo.vue?vue&type=script&lang=js&"
import style0 from "./familyInfo.vue?vue&type=style&index=0&id=adf50404&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf50404",
  null
  
)

export default component.exports